import {request} from '@/http/http.js'

// FAQ列表 /api/faq/list
export function getFaq(query) {
  return request({
    url: '/api/faq/list',
    method: 'get',
    params:query
  })
}

export function getFaqBySubtitle(query) {
  return request({
    url: '/api/faq/by_subtitle',
    method: 'get',
    params: query
  })
}

export function getFaqByRand(query) {
  return request({
    url: '/api/faq/rand',
    method: 'get',
    params: query
  })
}

export function getPopularFaqs(query) {
  return request({
    url: '/api/faq/popular',
    method: 'get',
    params: query
  })
}

export function listFaqCategoires(query) {
  return request({
    url: '/api/faq/list_category',
    method: 'get',
    params: query
  })
}

export function listCategoryFaqs(query) {
  return request({
    url: '/api/faq/list_by_cat',
    method: 'get',
    params: query
  })
}

export function submitEvaluateStar(query) {
  return request({
    url: '/api/faq/stars',
    method: 'POST',
    data: query,
    headers: {
     'Content-Type': 'application/json',
    }
  })
}


